import log from 'chameleon/ui-stack/utilities/log';
import { toast } from 'chameleon/ui-stack/ui/toast';
import { isQuizSharedQuery } from 'chameleon-src/queries';

const checkQuizShare = async (client, quizId) => {
  try {
    const response = await client.query({
      query: isQuizSharedQuery,
      fetchPolicy: 'network-only',
      variables: {
        assessmentId: quizId,
      },
    });
    const { assessment: quiz } = (response && response.data) || {};
    return quiz && quiz.isShared;
  } catch (err) {
    toast('An error occured, could not check quiz share status');
    log(err);
  }
};

export default checkQuizShare;
